module.exports = __webpack_public_path__ + "img/014.eb671396.png";